import { useEffect } from "react";
import { useConfigurationSelector } from "../context/ConfigurationReduxContext";
import { useCsCfgObject } from "../hooks/useCsCfgObject";
import { useSubstructureApi } from "../hooks/useSubstructureApi";
import { getCurrentPath } from "../reducers/selectors";
import { ConfigurationItemKind } from "./ConfigurationItemKind";
import { useConfigurationNavigationApi, useConfigurationNavigationItems, } from "./useConfigurationNavigationState";
function useConfigurationPathSwitcher(options) {
    const { path } = options;
    const items = useConfigurationNavigationItems();
    const { enterSubCfgObject } = useSubstructureApi();
    useEffect(() => {
        // find the first parent configuration object
        const itemsTopToBottom = [...items].reverse();
        const parentConfigurationObject = itemsTopToBottom.find((item) => item.kind === ConfigurationItemKind.ConfigurationObject);
        if (parentConfigurationObject == null) {
            return;
        }
        // if the current path includes the item's, we don't need to navigate
        if (parentConfigurationObject.path.startsWith(path)) {
            return;
        }
        // path mismatch, we need to navigate to the correct path
        enterSubCfgObject({ path: parentConfigurationObject.path });
    }, [enterSubCfgObject, items, path]);
}
function useResetItemsOnPathChange() {
    const { setItems } = useConfigurationNavigationApi();
    const currentPath = useConfigurationSelector(getCurrentPath);
    useEffect(() => {
        // clear items when the path changes, e.g. when using enterSubCfgObject
        setItems([]);
    }, [setItems, currentPath]);
}
/**
 * Used in combination with `<ConfigurationTree />` to change the current configuration object.
 *
 *
 * Needs to be placed directly inside `<ConfigurationRenderer />`
 */
export function ConfigurationPathSwitcher() {
    const cfgObject = useCsCfgObject();
    const { path } = cfgObject;
    useResetItemsOnPathChange();
    useConfigurationPathSwitcher({ path });
}
//# sourceMappingURL=ConfigurationPathSwitcher.js.map